/*
*
*  kongwm   vue 全局 filter
*
*/

/*
*   使用 tool  各种工具
*/



let filterTool = {
    numToDate: function (value) {
        if(typeof value === 'number' && value != null){
            value = value.length === 13 ? value : value * 1000;
            return new Date(value);
        }
        return value;
    },
    dateToNum: function (value) {
        if(value && value !== null){
            return new Date(value).getTime();
        }
        return value;
    },
    /*保持小数点*/
    toFixed1: function (value, num){  // NumberObject.toFixed(num)  new Number(999).toFixed (4)
        if(value && value !== null){
            return value.toFixed(num);
        }
        return value;
    },
    companyNature: function (num) {
       let list = [  //企业性质  对应 公司类型
           {id: 1, 'title': '私募投资公司'},
           {id: 2, 'title': '公募基金公司'},
           {id: 3, 'title': '银行'},
           {id: 4, 'title': '证券公司'},
           {id: 5, 'title': '信托公司'},
           {id: 6, 'title': '审计机构'},
           {id: 7, 'title': '法律顾问'},
           {id: 8, 'title': '投资顾问'},
           {id: 9, 'title': '行政管理人'},
           {id: 10, 'title': '上市公司'},
           {id: 11, 'title': '期货公司'},
           {id: 12, 'title': '工作室'},
           {id: 13, 'title': '证券公司子公司'},
           {id: 14, 'title': '期货公司子公司'},
           {id: -1, title: '其他'}
       ];
       for ( let i=0; i<list.length; i++){
           if(num === list[i].id){
               return list[i].title;
           }
       }
        return num;
    },
    peopleType: function(num){
        let list =[
            {id: 1, 'title': '基金经理'},
            {id: 2, 'title': '研究员'},
            {id: 3, 'title': '联系人'},
            {id: -1, 'title': '其他'}
        ];
        for ( let i=0; i<list.length; i++){
            if(num === list[i].id){
                return list[i].title;
            }
        }
        return '其他';
    },
    selectList: function(num){
        let list = [ //运行状态
            {id: 1, 'title': '募集中'},
            {id: 2, 'title': '开放运行'},
            {id: 3, 'title': '封闭运行'},
            {id: 4, 'title': '提前清算'},
            {id: 5, 'title': '到期清算'},
            {id: 6, 'title': '发行失败'}
        ];
        for ( let i=0; i<list.length; i++){
            if(num === list[i].id){
                return list[i].title;
            }
        }
        return num;
    },
    getMsgType: function(num){
          let list =[
              {id: 1, 'title': '承诺函'},
              {id: 2, 'title': '公司'},
              {id: 3, 'title': '产品'},
              {id: 4, 'title': '经理'},
              {id: 5, 'title': '净值'}
          ];
        for ( let i=0; i<list.length; i++){
            if(num === list[i].id){
                return list[i].title;
            }
        }
        return num;
    },
    getAuditStatus: function(num){
        let list =[
            {id: -2, 'title': '草稿'},
            {id: 0, 'title': '待审核'},
            {id: 1, 'title': '审核通过'},
            {id: -1, 'title': '审核不通过'}
        ];
        for ( let i=0; i<list.length; i++){
            if(num === list[i].id){
                return list[i].title;
            }
        }
        return num;
    },

    /*
	*	DateSplit:指定日期分隔符，例如2017-7-4
	*	DateToClock:指定日期和时间中间的分隔符
	*	ClockSplit:指定时间分隔符，例如11:02
	*/
    setTime: function(value, secFlag){
        if(value == null || !value || typeof value !=  'number'){
            return null;
        }
        // 默认分隔符
        let DateSplit =  '-';
        let DateToClock =  ' ';
        let ClockSplit =  ':';
        let getTime =  function(){
            return new Date(value);
        };
        let getYear =  function(){
            return getTime().getFullYear();
        };
        let getMonth = function(){
            return (getTime().getMonth()+1) >= 10 ? (getTime().getMonth()+1) : '0'+(getTime().getMonth()+1) ;
        };
        let getHours= function(){
            return getTime().getHours();
        };
        let getMinutes =  function(){
            return getTime().getMinutes();
        };
        let getSeconds = function(){
            return getTime().getSeconds();
        };
        let getDate = function(){
            return getTime().getDate() >= 10 ? getTime().getDate() : '0' + getTime().getDate() ;
        };
        let getDay = function() {
            return (getTime().getDay() + 1)
        };
        switch(secFlag) {
            case 'yyyy-mm-dd':
                return getYear() + DateSplit + getMonth() + DateSplit +getDate();
                break;
            case 'hh:mm:ss':
                return getHours() + ClockSplit + getMinutes()+ getSeconds();
            default:
                return (getYear() + DateSplit + getMonth() + DateSplit + getDate() +  DateToClock + getHours() + ClockSplit + getMinutes()+(secFlag ? ClockSplit + getSeconds() : '' ));
        }
    }
};

export default  filterTool;


// WEBPACK FOOTER //
// ./src/util/filter.js